import { Component, Output, EventEmitter } from '@angular/core';
import { SimulatorV2Component } from './simulator-v2.component';

@Component({
  selector: 'app-simulator-popup',
  standalone: true,
  imports: [SimulatorV2Component],
  template: `
    <div class="popup-overlay" (click)="fecharSeClicouFora($event)">
      <div class="popup-box" role="dialog" aria-modal="true">
        <button class="btn-fechar" (click)="fechar.emit()" aria-label="Fechar">✕</button>
        <div class="popup-headline">
          <p class="popup-headline-top">SIMULE AGORA</p>
          <p class="popup-headline-sub">o custo do seu sistema</p>
        </div>
        <app-simulator-v2 [compacto]="true" (concluido)="fechar.emit()"></app-simulator-v2>
      </div>
    </div>
  `,
  styles: [`
    .popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      overflow-y: auto;
    }

    .popup-box {
      position: relative;
      background: #1e1e1e;
      border: 1px solid rgba(255, 107, 0, 0.4);
      border-radius: 16px;
      box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6), 0 8px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 107, 0, 0.15), 0 0 24px rgba(255, 107, 0, 0.12);
      width: 90vw;
      max-width: 440px;
      max-height: 90vh;
      overflow: hidden auto;
      padding: 20px;
    }

    .btn-fechar {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      color: rgba(255, 255, 255, 0.6);
      font-size: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;
      z-index: 1;
      line-height: 1;
      padding: 4px;
    }

    .btn-fechar:hover { color: #ffffff; }

    .popup-headline {
      text-align: center;
      margin: 0 28px 0;
      padding-bottom: 16px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .popup-headline-top {
      color: #FF6B00;
      font-size: 1.4rem;
      font-weight: 800;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      margin: 0;
      line-height: 1.2;
    }

    .popup-headline-sub {
      color: rgba(255, 255, 255, 0.75);
      font-size: 1rem;
      font-weight: 400;
      margin: 4px 0 0;
      line-height: 1.3;
    }

    @media (max-width: 640px) {
      .popup-box { padding: 16px; }
      .popup-headline { margin: 0 20px 0; }
      .popup-headline-top { font-size: 1.2rem; }
    }
  `]
})
export class SimulatorPopupComponent {
  @Output() fechar = new EventEmitter<void>();

  fecharSeClicouFora(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('popup-overlay')) {
      this.fechar.emit();
    }
  }
}
